define('controller/OnlineMeetingController',['require','lib/controller/BaseController','view/controller/online-meeting/OnlineMeetingView','model/OnlineMeetingModel'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var OnlineMeetingView = require('view/controller/online-meeting/OnlineMeetingView');
    var OnlineMeetingModel = require('model/OnlineMeetingModel');

    /**
     * Online Meeting Controller
     *
     * @class OnlineMeetingController
     */
    return BaseController.extend({
        
        _meetingModel: null,
        _isProvider: false,

        /**
         * index action, displays list of images
         */
        onlineMeetingView: function (id, hash) {
            return this._defaultAction(id, hash, false);
        },

        onlineMeetingProvider: function (id, hash) {
            return this._defaultAction(id, hash, true);
        },
        
        _defaultAction: function (id, hash, isProvider) {
            this._isProvider = isProvider;
            var model = this._meetingModel = new OnlineMeetingModel({
                id: id
            }, {
                hash: hash,
                is_provider: ~~isProvider
            });
            
            this.listenTo(model, 'sync', this._runRedirects);
            
            model.fetch();
            
            var view = new OnlineMeetingView({
                model: model,
                is_provider: ~~isProvider
            });
            
            this.listenTo(view, 'start', this._startMeeting);

            this.getMainLayout().getContentRegion().show(view);
        },
        
        _runRedirects: function (model) {
            if (this._isProvider) {
                if (model.get('start_url')) {
                    window.location = model.get('start_url');
                } else if (model.get('is_started')) {
                    this._startMeeting();
                }
            } else {
                if (model.get('join_url')) {
                    window.location = model.get('join_url');
                }
            }
        },
        
        _startMeeting: function () {
            if (this._isProvider) {
                if (this._meetingModel.get('start_url')) {
                    // console.log('second redirect');
                    window.location = this._meetingModel.get('start_url');
                } else {
                    this._meetingModel.setOption('start', true);
                    this._meetingModel.fetch();
                }
            }
        }
        
    });

});
